const accordion = () => {
  const accordions = document.querySelectorAll(".paragraph-accordion");

  for (const accordion of accordions) {
    const items = accordion.querySelectorAll(".paragraph-accordion-section");
    for (const item of items) {
      const header = item.querySelector(".paragraph-accordion-section-header");

      header.addEventListener("click", () => {
        item.classList.toggle("is-open");
      });
    }
  }
};

export default accordion;
